import { useContext } from "react";
import styled from "styled-components";
import { TooltipButton } from "../../../../../../../common/Tooltip/Tooltip";
import { ClientContext } from "../../../../ClientContext/ClientContext";
import useCompanyPolicies from "../BottomPanel/BPPolicies/useCompanyPolicies";
import useCompanyItem from "../useCompanyItem";

const CompanyPoliciesRecap = () => {
  const { company, actions } = useCompanyItem();
  const { productTypes } = useContext(ClientContext);
  const { onChangePolicyStatusFilter } = useCompanyPolicies();

  // const policiesStatus = company.policies.map((p) => tools.findIn(POLICIES_STATUS, p.status, "id"));
  const POLICY_STATUS_CANCELED = [
    20, // Suspendu
    30, // Résilié
  ];

  const companyProducts = {};
  let policiesCanceled = [];
  let policiesValid = [];

  if (company.policies) {
    /**
     * Get only policies with status canceled
     */
    policiesCanceled = company.policies.filter((p) =>
      POLICY_STATUS_CANCELED.includes(p.status)
    );

    /**
     * Get only policies with valid status
     */
    policiesValid = company.policies.filter(
      (p) => !POLICY_STATUS_CANCELED.includes(p.status)
    );

    policiesValid.forEach((policy) => {
      const productTypeRef = productTypes.find(
        (p) => p.id == policy?.product?.productType
      );

      if (productTypeRef) {
        const producerName = `${
          policy.producer?.company || policy.producer2?.company || ""
        }`;

        let entryRef = companyProducts[policy.product?.productType] || {
          count: 0,
          name: productTypeRef.name,
          productTypeModulrId: productTypeRef.modulrId,
          producerNames: producerName ? [producerName] : [],
          productType: policy.product?.productType,
        };

        companyProducts[policy.product?.productType] = {
          ...entryRef,
          status: policy.status,
          count: entryRef.count + 1,
          avecEcheancier: policy.avecEcheancier,
          avecMensualisation: policy.avecMensualisation,
          producerNames:
            entryRef.producerNames.includes(producerName) && producerName
              ? entryRef.producerNames
              : [...entryRef.producerNames, producerName],
        };
      }
    });
  }
  const openPolicy = (product, isCanceled = false) => {
    actions.openBottomPanel("POLICIES", product);
    if (isCanceled) {
      onChangePolicyStatusFilter({ target: { value: [20, 30] } });
    } else {
      onChangePolicyStatusFilter({ target: { value: [0, 10] } });
    }
  };

  const productList = Object.values(companyProducts);

  return (
    <Recap>
      {productList.length === 0 && !policiesCanceled.length ? (
        <div className="recap__empty">Aucun contrat actif</div>
      ) : (
        <div className="recap__products">
          {productList.map((product) => (
            <div
              className="recap__product"
              key={`cpproduct${company.id}${product.name}`}
            >
              <button
                type="button"
                className="recap__product-btn"
                onClick={() => openPolicy(product)}
                title={`Voir les contrats ${product.name}`}
              >
                <span className="recap__count">{product.count}</span>
                <span className="recap__name">{product.name}</span>
                {product.avecEcheancier && (
                  <span className="generic-tooltip">
                    <span className="recap__flag">E</span>
                    <span className="generic-tooltip-content text-dark">
                      Avec échéancier
                    </span>
                  </span>
                )}
                {product.avecMensualisation && (
                  <span className="generic-tooltip">
                    <span className="recap__flag">M</span>
                    <span className="generic-tooltip-content text-dark">
                      Avec mensualisation
                    </span>
                  </span>
                )}
              </button>
              {product.producerNames.includes("PERCEVAL") &&
              product.producerNames.length == 1 ? null : (
                <TooltipButton
                  tooltipContent={
                    <div className="px-1">
                      <div>
                        <strong style={{ whiteSpace: "nowrap" }}>
                          Gestionnaires :
                        </strong>
                      </div>
                      {product.producerNames.join(", ")}
                    </div>
                  }
                >
                  <i className="text-primary fa fa-handshake recap__handshake" />
                </TooltipButton>
              )}
            </div>
          ))}
        </div>
      )}

      {policiesCanceled.length > 0 && (
        <button
          type="button"
          className="recap__canceled"
          onClick={() => openPolicy(policiesCanceled[0].product, true)}
          title="Voir les contrats résiliés / suspendus"
        >
          <span className="recap__count recap__count--danger">
            {policiesCanceled.length}
          </span>
          Résilié(s) / Suspendu(s)
        </button>
      )}
    </Recap>
  );
};

const Recap = styled.div`
  & .recap__empty {
    font-size: 12px;
    font-style: italic;
    color: var(--ds-slate-400);
  }

  & .recap__products {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  & .recap__product {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  & .recap__product-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 4px;
    margin: 0 -4px;
    border: 0;
    border-radius: 5px;
    background: transparent;
    font-size: 13px;
    font-weight: 600;
    color: var(--ds-slate-700);
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover {
      background: var(--ds-blue-soft);
      color: var(--ds-blue);
    }
  }

  & .recap__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    border-radius: 5px;
    background: var(--ds-blue);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  & .recap__count--danger {
    background: var(--ds-danger);
  }

  & .recap__flag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--ds-warning);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
  }

  & .recap__handshake {
    font-size: 13px;
  }

  & .recap__canceled {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding: 4px 6px;
    margin-left: -6px;
    border: 0;
    border-radius: 5px;
    background: transparent;
    font-size: 13px;
    font-weight: 600;
    color: var(--ds-danger);
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: var(--ds-danger-soft);
    }
  }
`;

export default CompanyPoliciesRecap;
